import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useStore } from 'vuex'
import AppHost from '@/utils/app'
import { onMounted, onUnmounted, ref } from 'vue'
import { getXaShortLink } from '@/apis/public'
import { RouterView, useRouter, useRoute } from 'vue-router'
import { useCommonShare } from '@/compositions/activity/index'
import { clearToast, getImageUrlBase64Data, showToastLoading } from '@/utils/tools'

import ReportLogoUrl from '@/assets/insurance/notice.png'

import wx from 'weixin-js-sdk'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const shorkLinkValue = ref('')
const store = useStore()
const { setMiniProgramShareInfo, getShareUrlInfo } = useCommonShare()
const baseInfoLoading = ref(false)

async function shareToWechatAndroind() {
  const iconData = await getImageUrlBase64Data(ReportLogoUrl)
  AppHost.shareToWeChat({
    iconStr: iconData.unHeaderData,
    title: '测试分享',
    description: '测试分享描述',
    shareUrl: 'weixin://dl/business/?t=aP3PuX9aUuq',
  })
}
async function shareToMomentsAndroind() {
  const iconData = await getImageUrlBase64Data(ReportLogoUrl)
  AppHost.shareToMoments({
    iconStr: iconData.unHeaderData,
    title: '测试分享',
    description: '测试分享描述',
    shareUrl: 'weixin://dl/business/?t=aP3PuX9aUuq',
  })
}
async function gennerateShort() {
  try {
    const data = await getXaShortLink({
      url: 'http://172.31.124.81:8080/activity/old-bring-news',
    })
    shorkLinkValue.value = `https://s.xa.com/mini?k=${data.key}`
    console.log('data', shorkLinkValue.value)
  } catch (error) {
    console.log('error', error)
  }
}

async function initPageInfo() {
  if (!store.state?.OldBringsNew?.activityGuid) {
    showToastLoading()
    baseInfoLoading.value = true
    try {
      await store.dispatch('OldBringsNew/initCommonInfo')
      if ($route.name === 'old-bring-new-index') {
        if (store?.state?.OldBringsNew?.isNewUser) {
          // 跳转新用户页面
          $router.replace({ name: 'activity-old-bring-new-new-user' })
        } else {
          // 跳转老用户页面
          $router.replace({ name: 'activity-old-bring-new-old-user' })
        }
      }
    } catch (error) {
      console.log('error', error)
    }
    clearToast()
    baseInfoLoading.value = false
  }
}

onMounted(() => {
  // wx.miniProgram.postMessage({ data: { foo: 'bara' } })
  // setTimeout(() => {
  //   wx.miniProgram.postMessage({
  //     data: {
  //       title: '老带新活动标题',
  //       desc: '老带新活动描述',
  //       imgUrl: 'http://hptest.xa.com/99A773317758857A881AD0391C2DD2FE.',
  //       link: 'http://172.31.124.81:8080/activity/old-bring-news',
  //     },
  //   })
  // }, 1000)
  setMiniProgramShareInfo()
  initPageInfo()
})

return (_ctx: any,_cache: any) => {
  return (!baseInfoLoading.value)
    ? (_openBlock(), _createBlock(_unref(RouterView), { key: 0 }))
    : _createCommentVNode("", true)
}
}

})